"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluginSettingsSchema = void 0;
const zod_1 = require("zod");
exports.PluginSettingsSchema = zod_1.z.object({
    // resolved by device policy manager into PluginVersion
    pluginUid: zod_1.z.string(),
    pluginVersion: zod_1.z.string(),
    // contributes to assignment
    configuration: zod_1.z.record(zod_1.z.string(), zod_1.z.any()),
    // call to set
    set: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
});
